export const paymentOriginRouteFactory = (
  originRoute: string,
  serviceLocationId?: string,
): string => {
  const serviceLocationIdInUrl = serviceLocationId
    ? `?serviceLocationId=${serviceLocationId}`
    : "";
  return `${originRoute}${serviceLocationIdInUrl}`;
};
